import { render, staticRenderFns } from "./Ports.vue?vue&type=template&id=0cadb6f4&scoped=true"
import script from "./Ports.vue?vue&type=script&lang=js"
export * from "./Ports.vue?vue&type=script&lang=js"
import style0 from "./Ports.vue?vue&type=style&index=0&id=0cadb6f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cadb6f4",
  null
  
)

export default component.exports